import { clearingApi } from "../../config/apiConfig";

export const getNewStations = async () => {
  try {
    const response = await clearingApi.get(`cdrs/sync-new-owners`);

    if (response?.status >= 300) {
      return false;
    }

    return response?.data || true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const getEvseLabelsByStationId = async (stationId) => {
  if (!stationId) {
    console.log("StationId not defined");
    return;
  }

  try {
    const response = await clearingApi.get(
      `api/v1/evse-labels/by-station/${stationId}`
    );

    return response.data;
  } catch (e) {
    console.error("Failed to get EVSE labels for station.", stationId, e);
  }
};

export const updateEvseLabel = async ({ stationId, evseId, label }) => {
  if (!stationId || !evseId || !label) {
    console.log("Insufficient arguments for updateEvseLabel");
    return;
  }

  try {
    const response = await clearingApi.post("api/v1/evse-labels", {
      stationId,
      evseId,
      label,
    });

    if (response?.status === 200 || response?.status === 201) {
      return true;
    }

    console.error(
      stationId,
      "Failed to update EVSE label for station. Response status:",
      response?.status
    );
    return false;
  } catch (e) {
    console.error("Failed to update EVSE label for station.", e);
  }
};

export const getAllStationIds = async () => {
  try {
    const response = await clearingApi.get(`station/all`);

    if (response?.status >= 300) {
      console.log("[getAllStationIds] get all response", response);
    }

    return response?.data?.map((st) => st?.stationId) || [];
  } catch (e) {
    console.error("Failed to get all stations", e);
    return [];
  }
};
